import React,{useEffect, useState} from 'react';
import insta from "../../Images/instagram.svg";
import linked from "../../Images/linkedin.svg";
import twitter from "../../Images/twitter.svg";
import dribbble from "../../Images/dribbble.svg";
import github from "../../Images/github.png";
import medium from "../../Images/medium.png";

export default function Social(){
    const [media, setMedia] = useState({
        matches: window.matchMedia("(max-width: 1180px)").matches
    });
    useEffect(()=> {
        const handler = e => setMedia({matches: e.matches});
        window.matchMedia("(max-width: 1180px)").addListener(handler);
    },[]);
    return(
        <div className="Social">
            {media.matches && (
                <div>
                <div className="social-intro" data-aos="zoom-out">
                <h2 className="social-Title">Always in touch with my vast social community</h2>
            </div>
            <div className="wrapper" >
                <a href="https://instagram.com/vikalp._.kaushik" className="social-div" data-aos="fade-up">
                    <img src={insta} className="social-img"/>
                    <div className="profile-details">
                        <div className="social-title">Instagram</div>
                        <p className="social-para">I share my projects, designs and layouts for aspiring developers with my instagram community.</p>
                    </div>
                </a>
                <a href="https://linkedin.com/in/vikalp-kaushik-99966a1ab" className="social-div" data-aos="fade-up">
                    <img src={linked} className="social-img"/>
                    <div className="profile-details">
                        <div className="social-title">Linkedin</div>
                        <p className="social-para">I share my process, guidance and work with my linkedin community.</p>
                    </div>
                </a>
                <a href="https://dribbble.com/vikalp2502" className="social-div" data-aos="fade-up">
                    <img src={dribbble} className="social-img"/>
                    <div className="profile-details">
                        <div className="social-title">Dribbble</div>
                        <p className="social-para">I share my interactive, creative UI/UX designs on Dribbble.</p>
                    </div>
                </a>
            </div>
            <div className="wrapper second">
                <a href="https://twitter.com/kaushik_vikalp" className="social-div" data-aos="fade-up">
                    <img src={twitter} className="social-img"/>
                    <div className="profile-details">
                        <div className="social-title">Twitter</div>
                        <p className="social-para">I share my projects and work link here.</p>
                    </div>
                </a>
                <a href="https://github.com/vikalp2502" className="social-div" data-aos="fade-up">
                    <img src={github} className="social-img new"/>
                    <div className="profile-details">
                        <div className="social-title">GitHub</div>
                        <p className="social-para">I share all my open source projects, work code with my github community.</p>
                    </div>
                </a>
                <a href="https://medium.com/@vikalpkaushik99" className="social-div" data-aos="fade-up">
                    <img src={medium} className="social-img new"/>
                    <div className="profile-details">
                        <div className="social-title">Medium</div>
                        <p className="social-para">I write articles/blogs of interesting full stack related content & my blogs have 10K+ views.</p>
                    </div>
                </a>
            </div>
            {/* <div className="social-footer" data-aos="fade-up">
                <p className="social-foot-para">You can support me if you love my content 🙂</p>
                <button className="social-btn">Write a Comment 💬</button>
            </div> */}
            </div>
            )}
            {!media.matches && (
                <div>
            <div className="social-intro">
                <h2 className="social-Title">I'm always in touch with my wider social community</h2>
            </div>
            <div className="wrapper" >
                <a href="https://instagram.com/vikalp._.kaushik" className="social-div">
                    <img src={insta} className="social-img"/>
                    <div className="profile-details">
                        <div className="social-title">Instagram</div>
                        <p className="social-para">I share my projects, designs and layouts for aspiring developers with my instagram community.</p>
                    </div>
                </a>
                <a href="https://linkedin.com/in/vikalp-kaushik-99966a1ab" className="social-div">
                    <img src={linked} className="social-img"/>
                    <div className="profile-details">
                        <div className="social-title">Linkedin</div>
                        <p className="social-para">I share my process, guidance and work with my linkedin community.</p>
                    </div>
                </a>
                <a href="https://dribbble.com/vikalp2502" className="social-div">
                    <img src={dribbble} className="social-img"/>
                    <div className="profile-details">
                        <div className="social-title">Dribbble</div>
                        <p className="social-para">I share my interactive, creative UI/UX designs on Dribbble.</p>
                    </div>
                </a>
            </div>
            <div className="wrapper second">
                <a href="https://twitter.com/kaushik_vikalp" className="social-div">
                    <img src={twitter} className="social-img"/>
                    <div className="profile-details">
                        <div className="social-title">Twitter</div>
                        <p className="social-para">I share my projects and work link here.</p>
                    </div>
                </a>
                <a href="https://github.com/vikalp2502" className="social-div">
                    <img src={github} className="social-img new"/>
                    <div className="profile-details">
                        <div className="social-title">GitHub</div>
                        <p className="social-para">I share all my open source projects, work code with my github community.</p>
                    </div>
                </a>
                <a href="https://medium.com/@vikalpkaushik99" className="social-div">
                    <img src={medium} className="social-img new"/>
                    <div className="profile-details">
                        <div className="social-title">Medium</div>
                        <p className="social-para">I write articles/blogs of interesting full stack related content & my blogs have 10K+ views.</p>
                    </div>
                </a>
            </div>
            {/* <div className="social-footer">
                <p className="social-foot-para">You can support me if you love my content 🙂</p>
                <button className="social-btn">Write a Comment 💬</button>
            </div> */}
            </div>
            )}
        </div>
    )
}